import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { Provider } from 'react-redux';
import { store } from './redux/Store';
import axios from 'axios';
import './styles/styles.scss';

// axios.defaults.baseURL = 'http://localhost:3001';
// axios.defaults.baseURL = 'https://countries-back-end-ts.onrender.com';
axios.defaults.baseURL = 'https://countries-make-ts.onrender.com';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <Provider store={store} >
      <App />
    </Provider>
  </React.StrictMode>
);
